import { EXPLICIT_CONSENT_GIVEN } from '../../../../actions/user';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { ConsentState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/privacy';

const INITIAL_STATE: ConsentState = {
  consent: false,
};

const privacy = (state: ConsentState = INITIAL_STATE, action: Action): ConsentState => {
  switch (action.type) {
    case EXPLICIT_CONSENT_GIVEN:
      return action.payload;
    default:
      return state;
  }
};

export default privacy;
export const get = (state: ConsentState): ConsentState => state;
